import { useState } from 'react';

import { Heading, Modal } from '@zillow/constellation-10';

import MultiplexWarningBanner from '../../MultiplexWarningBanner';
import PaymentDetails from '../../Payment/PaymentDetails';

import type { FreemiumChargeResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { FreemiumDatarouterError } from '../FreemiumErrorModal';

type Props = {
  listingAlias: string;
  isRenderedInPageView: boolean;
  onClose: () => void;
  onPaymentMethodChange?: () => void;
  handleFreemiumChargeSuccess: (response: FreemiumChargeResponseWebDto) => void;
  onFreemiumChargeError: (error: FreemiumDatarouterError) => void;
  isInBuildingGroup?: boolean;
};

/**
 * We want to disable closing the modal when a payment is processing.
 * We add the logic here as we need to prevent outside click, esc, and close btn click actions
 * and the logic needed is within the child component.
 *
 * Once the payment is complete we close the modal automatically from PremiumPaymentGateway
 * via component removal
 */
const PaymentModal = ({
  handleFreemiumChargeSuccess,
  onFreemiumChargeError,
  listingAlias,
  isRenderedInPageView,
  onClose,
  onPaymentMethodChange,
  isInBuildingGroup = false,
}: Props) => {
  const [isChargeFetching, setIsChargeFetching] = useState(false);
  const [headingText, setHeadingText] = useState('Credit card information');

  return (
    <Modal
      useDismissProps={{ escapeKey: isChargeFetching === false, outsidePress: isChargeFetching === false }}
      closeButton={isChargeFetching === false ? undefined : <span hidden />}
      header={<Heading level={2}>{headingText}</Heading>}
      body={
        <>
          <MultiplexWarningBanner isInBuildingGroup={isInBuildingGroup} />
          <PaymentDetails
            listingAlias={listingAlias}
            isRenderedInPageView={isRenderedInPageView}
            onPaymentMethodChange={onPaymentMethodChange}
            setIsChargeFetching={setIsChargeFetching}
            setHeadingText={setHeadingText}
            onFreemiumChargeSuccess={handleFreemiumChargeSuccess}
            onFreemiumChargeError={onFreemiumChargeError}
          />
        </>
      }
      onOpenChange={(open) => !open && onClose()}
      open={true}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

export default PaymentModal;
